import { animeList } from "@/mocks/animeData";
import type { Anime, AnimeFilter } from "@/types/anime";

export const allAnime: Anime[] = animeList;

export function getAnimeById(id?: string): Anime | undefined {
  if (!id) return undefined;
  return allAnime.find((item) => item.id === id);
}

export function formatDate(value: string): string {
  return value.replace(/-/g, ".");
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function sortAnime(list: Anime[], sort: string): Anime[] {
  const next = [...list];
  if (sort === "popular") {
    next.sort((a, b) => b.views - a.views);
    return next;
  }
  if (sort === "alpha") {
    next.sort((a, b) => a.title.localeCompare(b.title, "zh-Hans-CN"));
    return next;
  }
  next.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
  return next;
}

export function filterAnime(list: Anime[], filter: Partial<AnimeFilter>): Anime[] {
  const result = list.filter((item) => {
    if (filter.category && filter.category !== "all" && item.category !== filter.category) {
      return false;
    }
    if (filter.region && filter.region !== "all" && item.region !== filter.region) {
      return false;
    }
    if (filter.year && filter.year !== "all" && String(item.year) !== filter.year) {
      return false;
    }
    if (filter.status && filter.status !== "all" && item.status !== filter.status) {
      return false;
    }
    return true;
  });
  return sortAnime(result, filter.sort || "updated");
}

export function searchAnime(list: Anime[], keyword: string): Anime[] {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return list.filter((item) => {
    const pool = [
      item.title,
      item.originalTitle,
      item.category,
      item.region,
      item.author,
      item.studio,
      item.synopsis,
      ...item.tags,
    ]
      .join(" ")
      .toLowerCase();
    return pool.includes(query);
  });
}

export function getLatest(limit: number): Anime[] {
  return sortAnime(allAnime, "updated").slice(0, limit);
}

export function getPopular(limit: number): Anime[] {
  return sortAnime(allAnime, "popular").slice(0, limit);
}

export function getFeatured(): Anime[] {
  return allAnime.filter((item) => item.featured);
}

export function getRelated(current: Anime, limit = 4): Anime[] {
  const scored = allAnime
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.category === current.category) score += 3;
      score += item.tags.filter((tag) => current.tags.includes(tag)).length * 2;
      if (item.region === current.region) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function countByCategory(category: string): number {
  return allAnime.filter((item) => item.category === category).length;
}